import React, { FC } from 'react';

const Divider: FC = () => {
  return (
    <>
      <section className="">
        <div className="divider divider__img" />
      </section>
    </>
  );
};

export default Divider;
